import { bff_prefix } from '@/consts';
import { upload } from '@/typings/open.platform.forum_bff';
import { request } from '@/utils/request';

class Service {
  async uploadImage(req: FormData) {
    const res = await request<typeof req, upload.UploadPicResp>({
      url: `${bff_prefix}/upload_image`,
      data: req,
      method: 'POST',
    });
    return res.data;
  }
}

export const uploadService = new Service();
